<template>
  <div style="width: 100%;" class=" overflow-auto px-16px pt-16px pb-16px">
    <div class="search flex items-center gap-4px">
      <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search"
        style="margin-right: 16px;" />
      <el-button type="primary" @click="handleSearch" style="background-color: #2a66ff;">搜索</el-button>
    </div>
    <div class="categry">
      <div @click="handleRecommend" :class="curTab === 0 ? 'select-bg' : ''">推荐</div>
      <div class="category">
        <div class="category-title" :class="curTab === 1 ? 'select-bg' : ''">{{ categoryName }}</div>
        <el-cascader style="width: 120px;border: none; opacity: 0; position: absolute; top: 0; left: 0;"
          v-model="cascaderValue" @change="handleChange" id="category" ref="cascaderRef" :options="menuList" :props="{
            value: 'id',
            label: 'name',
            children: 'children'
          }" :show-all-levels="false" clearable placeholder="请选择分类">
        </el-cascader>
      </div>
    </div>
    <div class="templatelist" v-show="curTab == 0">
      <div class="list" v-for="item in templateItems" :key="item.id">
        <TemplateItem :template="item" />
      </div>
    </div>
    <div v-if="templateItems.length === 0 && curTab == 0" class="w-full h-full flex justify-center items-center">
      <el-empty description="暂无数据" />
    </div>
    <div v-show="curTab == 1">
      <categoryTemplate ref="categoryTemplateRef" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { ElInput, ElButton, ElCascader, ElEmpty } from 'element-plus'

import { Search } from '@element-plus/icons-vue'
import { getCategories, recommendations } from '@/api/affairs'
import { onMounted } from 'vue'
// @ts-ignore
import TemplateItem from './TemplateItem.vue'
// @ts-ignore
import categoryTemplate from './categoryTemplate.vue'
const menuList = ref([])
const props = defineProps<{
  type?: string
}>()
onMounted(() => {

  getCategories({ type: props.type == 'team' ? 2 : 1, category_type: 1 }).then(res => {
    menuList.value = res.data.data
  })
  getList()
})
const curTab = ref(0)
const cascaderValue = ref([])
const searchValue = ref('')
const categoryName = ref('分类')
const cascaderRef = ref()
const categoryTemplateRef = ref()
const handleChange = (val) => {
  const info = cascaderRef.value?.getCheckedNodes()[0]?.data
  categoryName.value = info.name
  curTab.value = 1
  if (info.id) {
    categoryTemplateRef.value.searchTemplates(info.id, searchValue.value)
    // console.log(info.id, searchValue.value)
  }
}
const handleSearch = () => {
  curTab.value = 1
  categoryName.value = '分类'
  cascaderValue.value = []
  categoryTemplateRef.value.searchTemplates('', searchValue.value)
}
const handleRecommend = () => {
  categoryName.value = '分类'
  cascaderValue.value = []
  curTab.value = 0
}
const templateItems = ref([])

const getList = () => {
  recommendations({ hotType: 1, size: 20, type: 1 }).then((res) => {
    const data = res.data.data
    templateItems.value = data
  })
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.categry {
  margin-top: 12px;
  border-bottom: 1px solid rgb(230, 230, 230);
  height: 40px;
  display: flex;
  align-items: center;
  color: #38393b;
  cursor: pointer;
  gap: 20px;
}

.category {
  position: relative;
  height: 40px;

  .category-title {
    width: 120px;
    top: 0;
    height: 40px;
    position: absolute;
    display: flex;
    align-items: center;
  }
}

.select-bg {
  color: black;
  font-weight: bolder;
}

.templatelist {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 16px;

  .list {
    width: 140px;
  }
}
</style>